// theme
import { ThemeColorPresets } from "~types/settings";
import palette from "../theme/palette";
// @type

// ----------------------------------------------------------------------

export const colorPresets = [
  // DEFAULT
  {
    name: "default",
    lighter: "#D9D6FE",
    light: palette.light.primary.light,
    main: palette.light.primary.main,
    dark: palette.light.primary.dark,
    darker: "#5925DC",
    contrastText: palette.light.primary.contrastText,
  },
  // PURPLE
  {
    name: "purple",
    lighter: "#EBD6FD",
    light: "#B985F4",
    main: "#7635dc",
    dark: "#431A9E",
    darker: "#200A69",
    contrastText: "#fff",
  },
  // CYAN
  {
    name: "black",
    lighter: "#D1FFFC",
    light: "#76F2FF",
    main: "#1CCAFF",
    dark: "#0E77B7",
    darker: "#053D7A",
    contrastText: palette.light.grey[800],
  },
];

export const defaultPreset = colorPresets[0];
export const purplePreset = colorPresets[1];
export const blackPreset = colorPresets[2];

export default function getColorPresets(presetsKey: ThemeColorPresets) {
  return {
    purple: purplePreset,
    black: blackPreset,
    default: defaultPreset,
  }[presetsKey];
}
